// src/components/admin/pagebuilder/BuilderSidebar.jsx
import React from "react";
import { Droppable, Draggable } from "@hello-pangea/dnd";

const COMPONENTS = [
  { id: "text", label: "Texto" },
  { id: "image", label: "Imagem" },
  { id: "button", label: "Botão" },
  { id: "html", label: "HTML" },
  { id: "forum", label: "Fórum" },
];

export default function BuilderSidebar() {
  return (
    <aside className="w-64 bg-white border-r p-4">
      <h3 className="font-bold mb-4">Componentes</h3>

      <Droppable droppableId="sidebar" isDropDisabled>
        {(p) => (
          <div ref={p.innerRef} {...p.droppableProps}>
            {COMPONENTS.map((c, i) => (
              <Draggable key={c.id} draggableId={c.id} index={i}>
                {(p) => (
                  <div
                    ref={p.innerRef}
                    {...p.draggableProps}
                    {...p.dragHandleProps}
                    className="p-3 mb-2 bg-gray-100 rounded cursor-grab hover:bg-indigo-100"
                  >
                    {c.label}
                  </div>
                )}
              </Draggable>
            ))}
            {p.placeholder}
          </div>
        )}
      </Droppable>
    </aside>
  );
}
